module.exports = __webpack_public_path__ + "img/rightText_zh.09de0419.png";